import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { SkipLink } from '@scp/ui-shared/components/buttons'; // eslint-disable-next-line import/no-relative-parent-imports

import { FullscreenLayoutBase } from '../FullscreenLayoutBase';
import { HeaderShadow, CenterColumn, LeftColumn, MainContent, MainScreen, RightColumn, SkipWrapper } from './baseComponents';
import { sideNavigationHolderBase } from './baseStyles';
import { MAIN_CONTENT_ID, TEXT } from './constants';
var SideNavigationHolder = styled.div(_templateObject(), sideNavigationHolderBase);
export var ScreenLayout = function ScreenLayout(_ref) {
  var children = _ref.children,
      leftColumn = _ref.leftColumn,
      sideNavigation = _ref.sideNavigation,
      rightColumn = _ref.rightColumn,
      _ref$fixedRightSideba = _ref.fixedRightSidebarWidth,
      fixedRightSidebarWidth = _ref$fixedRightSideba === void 0 ? true : _ref$fixedRightSideba;
  return React.createElement(React.Fragment, null, React.createElement(SkipWrapper, null, React.createElement(SkipLink, {
    skipToId: MAIN_CONTENT_ID,
    title: TEXT.SKIP_LINK
  })), React.createElement(FullscreenLayoutBase, null, !!sideNavigation && React.createElement(SideNavigationHolder, null, sideNavigation), React.createElement(MainScreen, null, React.createElement(MainContent, {
    id: MAIN_CONTENT_ID
  }, !!leftColumn && React.createElement(LeftColumn, null, leftColumn), React.createElement(CenterColumn, null, children)), rightColumn && React.createElement(RightColumn, {
    fixedWidth: fixedRightSidebarWidth
  }, rightColumn), React.createElement(HeaderShadow, null))));
};